import { render, staticRenderFns } from "./AppAdminDownloadAttachments.vue?vue&type=template&id=aa4d2f32&"
import script from "./AppAdminDownloadAttachments.vue?vue&type=script&lang=ts&"
export * from "./AppAdminDownloadAttachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports